<script setup>
import { storeToRefs } from 'pinia';
import { useStandingStore } from '../stores/standing-store';

/**
 * Standing
 */
const { standing, loading } = storeToRefs(useStandingStore());
</script>

<template>
  <div class="" style="height: calc(100vh - 60px)">
    <div class="row">
      <div
        id="offcanvasResponsive"
        class="offcanvas-lg offcanvas-start col-lg-2 d-flex flex-grow-1 position-fixed bottom-0 sidebar"
        tabindex="-1"
        aria-labelledby="offcanvasResponsiveLabel"
        v-if="!loading && standing"
      >
        <div class="offcanvas-header">
          <h5 id="offcanvasResponsiveLabel" class="offcanvas-title">Menu</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            data-bs-target="#offcanvasResponsive"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body d-flex flex-grow-1">
          <div class="d-flex flex-column flex-grow-1 p-3">
            <ul class="nav nav-pills flex-column mb-auto pt-4">
              <li class="nav-item">
                <RouterLink
                  :to="{
                    name: 'standing.manage.detail',
                    params: { standingId: standing.id },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/edit') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-sitemap me-2"></i>
                    Standing
                  </div>
                </RouterLink>
              </li>
              <li class="nav-item">
                <RouterLink
                  :to="{
                    name: 'standing.manage.event.list',
                    params: { standingId: standing.id },
                  }"
                  class="nav-link"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-calendar-check me-2"></i>
                    Event Approvals
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'standing.manage.setting.edit',
                    params: { standingId: standing.id },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/settings') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-cog me-2"></i>
                    Settings
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'standing.manage.security.list',
                    params: { standingId: standing.id },
                  }"
                  class="nav-link"
                  :class="{
                    active: $route.path.includes('/manage/securities/'),
                  }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-shield-check me-2"></i>
                    Security
                  </div>
                </RouterLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <main class="ms-lg-auto col-lg-10 px-md-4">
        <RouterView />
      </main>
    </div>
  </div>
</template>
